const userPayment = {
  userPayments: 'Pagos del administrador',
  showing: 'mostrado',
  userPaymentsOf: 'pagos',
  noUserPaymentsFound: 'No se encontraron pagos de usuario',
  table: {
    bonusPayment: 'Pago de bonificación',
    regularPayment: 'Pago regular'
  },
  actionsDropdown: {
    edit: 'Editar pago',
    delete: 'Eliminar pago',
    editInvoice: 'Editar factura',
    deleteInvoice: 'Eliminar factura',
  },
  tableDropdown: {
    quickActions: 'Acciones rápidas',
    refresh: 'Actualizar',
    exportUserPayments: 'Exportar',
    exportUserPaymentsCurrent: 'Exportar actual',
  },
  modal: {
    editPayment: 'Editar pago',
    email: 'Correo electrónico',
    amount: 'Importe',
    date: 'Fecha',
    paymentType: 'Tipo de pago',
    paymentDetails: 'Detalles del pago',
    successDelete: 'Pago eliminado correctamente',
    invoiceUpdated: 'Factura actualizada correctamente',
    invoiceDeleted: 'Factura eliminada correctamente',
    successUpdate: 'Pago actualizado correctamente',
  }
};

export default userPayment;
